export type PrivateAreaHistoryRecord = {
  id: string;
  date: string;
  type:
    | "renewal"
    | "tenant_change"
    | "rent_change"
    | "document_upload"
    | "document_delete"
    | "contract_end"
    | "created";
  description: string;
  note?: string;
  changes?: Array<{
    field: string;
    oldValue: string;
    newValue: string;
    corrected?: boolean;
    revisionHistory?: string;
  }>;
  contractDetails?: {
    tenantName?: string;
    tenantPhone?: string;
    tenantEmail?: string;
    startDate?: string;
    endDate?: string;
    monthlyRent?: number;
    deposit?: number;
    keyMoney?: number;
    remarks?: string;
    contractForm?: string;
    maintenanceFee?: number;
    pricingType?: "fixed" | "unit_quantity";
    unitPrice?: number;
    quantity?: number;
    quantityUnit?: string;
    rentStartDate?: string;
    cancellationDate?: string;
    depositAfter?: number;
    otherFees?: Array<{ label: string; amount: number }>;
  };
  corrected?: boolean;
  revisionHistory?: Array<{
    revised_at: string;
    revised_by: string;
    changes: Record<string, { before: any; after: any }>;
    reason: string;
  }>;
  createdBy?: string;
  updatedBy?: string;
  lastUpdatedAt?: string;
  isEdited?: boolean;
  tenantName?: string;
  uploadedDocuments?: Array<{
    s3_key: string;
    fileName: string;
    category: string;
  }>;
  deletedDocuments?: Array<{
    s3_key: string;
    fileName: string;
    category: string;
  }>;
  departureDate?: string;
  departureReason?: string;
};

export type PrivateAreaDetailState = {
  propertyName?: string;
  privateAreaName?: string;
  address?: string;
  tenantName?: string;
  tenantPhone?: string;
  tenantEmail?: string;
  startDate?: string;
  endDate?: string;
  monthlyRent?: number;
  deposit?: number;
  keyMoney?: number;
  status?: "active" | "ended";
  documentsCount?: number;
  history?: PrivateAreaHistoryRecord[];
};

export const REVISION_FIELD_LABELS: Record<string, string> = {
  tenant_name: "氏名",
  tenant_phone: "電話番号",
  tenant_email: "メールアドレス",
  contract_start_date: "契約開始日",
  contract_end_date: "契約終了日",
  monthly_rent: "月額賃料（税別）",
  security_deposit: "敷金",
  key_money: "礼金",
  // BE は revision_history.changes のキーとして contract_remarks を入れてくる
  contract_remarks: "備考",
  // 旧キー (互換のため残す)
  remarks: "備考",
  representative_name: "代表者名",
  contract_form: "契約形態",
  maintenance_fee: "共益費",
  rent_start_date: "賃料起算日",
  cancellation_date: "解約予定日",
  security_deposit_after: "償却後敷金",
  other_fees: "その他料金",
  // 契約者・連絡先・住所など (BE buildContractChanges で出る可能性)
  contractor_type: "契約者種別",
  address: "住所",
  rent_unit_price: "賃料単価",
  maintenance_fee_unit_price: "共益費坪単価",
  pricing_type: "料金体系",
  unit_price: "単価",
  quantity: "数量",
  quantity_unit: "単位",
};

export const formatDisplayDateTime = (input?: string | number | Date): string => {
  if (!input) return "";
  const d = new Date(input);
  if (Number.isNaN(d.getTime())) return String(input);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${y}/${m}/${day} ${hh}:${mm}`;
};
